'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.SystemConfiguration.ConfigurationParameterDialog', dependencies).controller('ConfigurationParameterModalController', require('./controllers/ConfigurationParameterModalController')).directive('rmConfigurationParameterModal', require('./directives/ConfigurationParameterModalDirective'));